<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="BtnPopup" (click)="GetArticleProcessByID()" style="display:none">Search</button>
        <button type="button" id="btnDeleteDT" (click)="DeleteArticleProcess()" style="display:none">Delete</button>
        <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>
        <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>
        <!--table-->
        <table #dataTable class="display" style="width:100%"></table>
        <!--Action popup Page-->
        <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-lg">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title"> {{title}} </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()"></button>
              </div>
              <!--popupbody-->
              <div class="modal-body" id="popupbody">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-8">
                      <b>Process Name<em>*</em></b>
                      <input id="Txt_ProcessName" type="text" maxlength="50" class="form-control" autocomplete="off">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12">
                      <b>Next Process Name</b>
                      <select id="ddlNextProcessID" class="form-control" multiple>
                        <option *ngFor="let item of GetProcessName" value={{item.ID}}>
                          {{item.ProcessName}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12">
                      <b>Previous Process Name</b>
                      <select id="ddlPreviousProcessID" class="form-control" >
                        <option *ngFor="let item of GetProcessName" value={{item.ID}}>
                          {{item.ProcessName}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="Txt_Transaction" class="control-label">Is Transaction</label>&nbsp;
                      <input type="checkbox" id="Txt_Transaction">
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" title="{{popUpButtonText}}" id="btnWF" (click)="AddUpdateArticleProcess()"> {{popUpButtonText}} </button>
              </div>
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
